import { inject, provideEnvironmentInitializer } from '@angular/core';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { provideSoftAppsModule, withLazySoftAppsModuleTranslation, withSoftAppsModuleRoutes } from '@softapps/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { dokumentationRoutes } from './documentation.routes';
import { SOFTLINE_PERMISSION_DOCUMENTATION } from './documentation.shared';

export function provideDokumentationModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'dokumentation',
        title: '#DOCUMENTATION.APP',
        icon: 'fa-regular fa-notebook',
        route: '/dokumentation',
        color: 'bg-warning text-black',
        permission: SOFTLINE_PERMISSION_DOCUMENTATION,
        group: getModuleGroupByName('Gewerbe'),
      },
      withSoftAppsModuleRoutes({ app: dokumentationRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      })
    ),
  ];
}

export const dokumentationProviders = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'dokumentation',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#DOCUMENTATION.APP',
      icon: 'fa-regular fa-notebook',
      route: '/dokumentation',
      permission: SOFTLINE_PERMISSION_DOCUMENTATION,
      color: 'bg-warning text-black',
      group: getModuleGroupByName('Gewerbe'),
    });
  }),
];
